import { render, staticRenderFns } from "./AdmissionCertificate.vue?vue&type=template&id=03a12c0d"
import script from "./AdmissionCertificate.vue?vue&type=script&lang=js"
export * from "./AdmissionCertificate.vue?vue&type=script&lang=js"
import style0 from "./AdmissionCertificate.vue?vue&type=style&index=0&id=03a12c0d&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/examreg-client-prod-tc/exam-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03a12c0d')) {
      api.createRecord('03a12c0d', component.options)
    } else {
      api.reload('03a12c0d', component.options)
    }
    module.hot.accept("./AdmissionCertificate.vue?vue&type=template&id=03a12c0d", function () {
      api.rerender('03a12c0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/printNTS/views/AdmissionCertificate.vue"
export default component.exports